module.exports = __webpack_public_path__ + "../assets/img/5522b89f180d8d7131ae8cfa1d887bd6.jpg";